import React from 'react'

const ResetIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.69775 8.72786C3.84359 8.65842 3.12484 8.30773 2.5415 7.67578C1.95817 7.04384 1.6665 6.29384 1.6665 5.42578C1.6665 4.89106 1.78977 4.38759 2.0363 3.91536C2.28282 3.44314 2.62831 3.05773 3.07275 2.75911L3.52067 3.20703C3.13178 3.4362 2.8297 3.75043 2.61442 4.14974C2.39914 4.54905 2.2915 4.97439 2.2915 5.42578C2.2915 6.12023 2.52067 6.72092 2.979 7.22786C3.43734 7.73481 4.01025 8.02648 4.69775 8.10286V8.72786ZM5.32275 8.72786V8.10286C6.0172 8.01953 6.59011 7.72613 7.0415 7.22266C7.49289 6.71918 7.71859 6.12023 7.71859 5.42578C7.71859 4.66884 7.45643 4.02821 6.93213 3.50391C6.40782 2.9796 5.7672 2.71745 5.01025 2.71745H4.80192L5.42692 3.34245L4.979 3.79036L3.59359 2.40495L4.979 1.01953L5.42692 1.46745L4.80192 2.09245H5.01025C5.94081 2.09245 6.729 2.4171 7.37484 3.06641C8.02067 3.71571 8.34359 4.50217 8.34359 5.42578C8.34359 6.29384 8.05366 7.04384 7.4738 7.67578C6.89393 8.30773 6.17692 8.65842 5.32275 8.72786Z'
      fill='currentColor'
    />
  </svg>
)

export default ResetIcon
